/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketReviewState } from './TicketReviewState';
import {
    TicketReviewStateFromJSON,
    TicketReviewStateFromJSONTyped,
    TicketReviewStateToJSON,
    TicketReviewStateToJSONTyped,
} from './TicketReviewState';
import type { ZendeskTicketData } from './ZendeskTicketData';
import {
    ZendeskTicketDataFromJSON,
    ZendeskTicketDataFromJSONTyped,
    ZendeskTicketDataToJSON,
    ZendeskTicketDataToJSONTyped,
} from './ZendeskTicketData';

/**
 * Cross-turn state for the customer_support_agent.
 * 
 * Round-tripped via ConversationMetadata; not visible to users or the LLM.
 * Holds everything the agent must remember between turns (the resolved ARTESCA
 * version, whether a ticket was already opened, etc.).
 * @export
 * @interface CustomerSupportAgentState
 */
export interface CustomerSupportAgentState {
    /**
     * 
     * @type {string}
     * @memberof CustomerSupportAgentState
     */
    zendeskTicketId?: string | null;
    /**
     * 
     * @type {ZendeskTicketData}
     * @memberof CustomerSupportAgentState
     */
    zendeskTicketDraft?: ZendeskTicketData | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerSupportAgentState
     */
    selectedArtescaVersion?: string | null;
    /**
     * 
     * @type {TicketReviewState}
     * @memberof CustomerSupportAgentState
     */
    ticketReview?: TicketReviewState;
}

/**
 * Check if a given object implements the CustomerSupportAgentState interface.
 */
export function instanceOfCustomerSupportAgentState(value: object): value is CustomerSupportAgentState {
    return true;
}

export function CustomerSupportAgentStateFromJSON(json: any): CustomerSupportAgentState {
    return CustomerSupportAgentStateFromJSONTyped(json, false);
}

export function CustomerSupportAgentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerSupportAgentState {
    if (json == null) {
        return json;
    }
    return {
        
        'zendeskTicketId': json['zendesk_ticket_id'] == null ? undefined : json['zendesk_ticket_id'],
        'zendeskTicketDraft': json['zendesk_ticket_draft'] == null ? undefined : ZendeskTicketDataFromJSON(json['zendesk_ticket_draft']),
        'selectedArtescaVersion': json['selected_artesca_version'] == null ? undefined : json['selected_artesca_version'],
        'ticketReview': json['ticket_review'] == null ? undefined : TicketReviewStateFromJSON(json['ticket_review']),
    };
}

export function CustomerSupportAgentStateToJSON(json: any): CustomerSupportAgentState {
    return CustomerSupportAgentStateToJSONTyped(json, false);
}

export function CustomerSupportAgentStateToJSONTyped(value?: CustomerSupportAgentState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'zendesk_ticket_id': value['zendeskTicketId'],
        'zendesk_ticket_draft': ZendeskTicketDataToJSON(value['zendeskTicketDraft']),
        'selected_artesca_version': value['selectedArtescaVersion'],
        'ticket_review': TicketReviewStateToJSON(value['ticketReview']),
    };
}

